import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import { TagIcon } from 'src/components/TagIcon/TagIcon'
import { css, CSSProp } from 'styled-components'

export const TagIconWithTooltip: React.FC<{
  icon: React.ReactElement
  iconBackgroundColor: string
  tooltipText: React.ReactNode
  borderWidth?: number
  testId?: string
  cssProps?: CSSProp
}> = (props): React.ReactElement => {
  return (
    <span
      css={css`
        position: relative;
        ${props.cssProps}
      `}
    >
      <TooltipIcon
        icon={
          <TagIcon
            testId={props.testId}
            backgroundColor={props.iconBackgroundColor}
            icon={props.icon}
            borderWidth={props.borderWidth}
          />
        }
      >
        {props.tooltipText}
      </TooltipIcon>
    </span>
  )
}
